import { render, staticRenderFns } from "./ResetPasswordForm.vue?vue&type=template&id=9a218526&"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/resources/calmit-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a218526')) {
      api.createRecord('9a218526', component.options)
    } else {
      api.reload('9a218526', component.options)
    }
    module.hot.accept("./ResetPasswordForm.vue?vue&type=template&id=9a218526&", function () {
      api.rerender('9a218526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ResetPasswordForm/ResetPasswordForm.vue"
export default component.exports